// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App.vue';
import store from './store';

Vue.filter('number', (n) => {
  if (typeof n !== 'number' || isNaN(n)) return n;

  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  render: h => h(App),
});



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/